<template>
  <div class="dropdown-container">
    <DropdownPrime 
      v-model="selectedValue" 
      :options="options" 
      optionLabel="Glosa" 
      optionValue="Id" 
      placeholder="Selecciona un Curso" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-tooltip="tooltipOpts"
      @change="emitSelection"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import CursoService from '@/services/CursoService';

function normId(v) {
  if (v === '' || v === undefined || v === null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export default {
  components: {
  },
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    tooltipOpts() {
      return {
        value: this.tooltip || '',
        position: 'bottom',
        disabled: !String(this.tooltip || '').trim(),
      };
    },
  },
  setup(props, { emit }) {
    const options = ref([]);
    const selectedValue = ref(normId(props.modelValue));

    const fetchOptions = async () => {
      try {
        const response = await CursoService.get(); // Llama al método getCursos
        options.value = response.data; // Asegúrate de que la respuesta tenga la estructura correcta
      } catch (error) {
        console.error('Error al cargar opciones:', error);
      }
    };

    const emitSelection = () => {
      emit('update:modelValue', normId(selectedValue.value));
    };

    watch(() => props.modelValue, (v) => {
      selectedValue.value = normId(v);
    });

    onMounted(() => {
      fetchOptions();
    });

    return {
      options,
      selectedValue,
      emitSelection,
    };
  }
}
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
}
</style>
